import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Typography, Breadcrumb, message, Spin } from 'antd';
import { ProductForm } from '../../components/Product/ProductForm';
import { productsService } from '../../services/products.service';
import { Product } from '../../types';

const { Title } = Typography;

const ProductDetail: React.FC = () => {
    const { id } = useParams<{ id: string }>();
    const navigate = useNavigate();
    const [product, setProduct] = useState<Product | undefined>(undefined);
    const [loading, setLoading] = useState(false);
    const [saving, setSaving] = useState(false);
    const isEditMode = !!id;

    useEffect(() => {
        const fetchProduct = async () => {
            if (!id) return;
            setLoading(true);
            try {
                const data = await productsService.getById(id);
                setProduct(data);
            } catch (error) {
                console.error('Failed to fetch product', error);
                message.error('Failed to load product details');
                navigate('/products/list');
            } finally {
                setLoading(false);
            }
        };

        if (isEditMode) {
            fetchProduct();
        }
    }, [id, navigate, isEditMode]);

    const handleSubmit = async (values: any) => {
        setSaving(true);
        try {
            if (isEditMode && id) {
                await productsService.update(id, values);
                message.success('Product updated successfully');
            } else {
                await productsService.create(values);
                message.success('Product created successfully');
            }
            navigate('/products/list');
        } catch (error) {
            console.error('Save failed', error);
            message.error('Failed to save product');
        } finally {
            setSaving(false);
        }
    };

    if (loading) {
        return <div style={{ textAlign: 'center', padding: 50 }}><Spin size="large" /></div>;
    }

    return (
        <div style={{ maxWidth: 1200, margin: '0 auto' }}>
            <Breadcrumb
                items={[
                    { title: <a onClick={() => navigate('/')}>Bảng điều khiển</a> },
                    { title: <a onClick={() => navigate('/products/list')}>Sản phẩm</a> },
                    { title: isEditMode ? 'Chỉnh sửa sản phẩm' : 'Sản phẩm mới' },
                ]}
                style={{ marginBottom: 16 }}
            />
            
            <div style={{ marginBottom: 24 }}>
                <Title level={2}>{isEditMode ? 'Chỉnh sửa sản phẩm' : 'Tạo sản phẩm mới'}</Title>
            </div>

            <ProductForm 
                initialValues={product} 
                onSubmit={handleSubmit} 
                loading={saving}
            />
        </div>
    );
};

export default ProductDetail;
